import {
  findRecord,
  updateRecord,
  deleteRecord,
  insertRecord,
  sortArray,
} from "./services";
import { toJalaali } from "jalaali-js";

const PersianMonths = {
  1: "فروردین",
  2: "اردیبهشت",
  3: "خرداد",
  4: "تیر",
  5: "مرداد",
  6: "شهریور",
  7: "مهر",
  8: "آبان",
  9: "آذر",
  10: "دی",
  11: "آبان",
  12: "اسفند",
};

async function deleteTour(tourId) {
  let res = await deleteRecord("tours", `id/=/${tourId}`);
  return res.status == 1;
}

async function searchTour(filterInputs) {
  let conditions = "",
    tourIds = [],
    res;
  if (filterInputs.transferType != 0) {
    res = await findRecord("tour_other_field_values", {
      conditions: `code/=/11@@val/like/${filterInputs.transferType}`,
      fields: "tour_id",
    });
    tourIds = res.reduce((total, value) => {
      return [...total, value.tour_id];
    }, []);
  }
  conditions += `mainprice/between/${filterInputs.priceRange.join(",")}`;
  if (tourIds.length > 0) {
    conditions += `@@id/in/${tourIds.join(",")}`;
  }
  if (filterInputs.title != "")
    conditions += `@@title/like/${filterInputs.title}`;
  if (filterInputs.stm != "")
    conditions += `@@stm/between/${filterInputs.stm - 90000},${
      filterInputs.stm + 90000
    }`;
  if (filterInputs.ftm != "")
    conditions += `@@ftm/between/${filterInputs.ftm - 90000},${
      filterInputs.ftm + 90000
    }`;
  if (filterInputs.duration != 0) {
    if (filterInputs.duration != 3) {
      let duration = filterInputs.duration == 1 ? 90000 : 180000;
      conditions += `@@(ftm - stm)/between/${duration - 43000},${
        duration + 43000
      }`;
    } else {
      conditions += `@@(ftm - stm)/>/180000`;
    }
  }
  return conditions;
}

async function getTours(conditions = "") {
  let tours = [],
    tourIds = [],
    formData = {
      fields: "id, title, main_status, stm, ftm, mtm",
    };
  if (conditions != "") formData.conditions = conditions;
  let res = await findRecord("tours", formData);
  res = sortArray(res, "mtm");
  tours = res.map((value) => {
    let result = {
      id: value.id,
      title: value.title,
      duration: "",
      transferType: "",
      main_status: value.main_status,
    };
    try {
      let stm = toJalaali(new Date(parseInt(value.stm) * 1000)),
        ftm = toJalaali(new Date(parseInt(value.ftm) * 1000)),
        time;
      if (stm.jm == ftm.jm) {
        time = `${stm.jd} تا  ${ftm.jd} ${PersianMonths[stm.jm]}`;
      } else {
        time = `${stm.jd} ${PersianMonths[stm.jm]} تا ${ftm.jd} ${
          PersianMonths[ftm.jm]
        }`;
      }
      result.duration = time;
    } catch (err) {
      console.log(err);
      console.log(value);
    }
    return result;
  });
  tourIds = res.map((value) => value.id);
  res = await findRecord("tour_other_field_values", {
    fields: "tour_id, val",
    conditions: `tour_id/in/${tourIds.join(",")}@@code/in/11`,
  });
  res.forEach((value) => {
    tours = tours.map((val) => {
      if (val.id == value.tour_id) {
        let type = "";
        value.val.split("+").forEach((v, i) => {
          let temp = v == 1 ? "هوایی" : v == 2 ? "زمینی" : "ریلی";
          if (i == 0) type += temp;
          else type += "،" + temp;
        });
        return { ...val, transferType: type };
      }
      return val;
    });
  });
  return tours;
}

async function getFilterMax() {
  let res = await findRecord("tours", {
    fields: "MAX(mainprice) as 'max'",
  });
  return parseInt(res[0].max);
}

async function toggleIsMainCatagory(id, state) {
  let res = await updateRecord("tour_tags", {
    keyvalues: { ismain: state },
    conditions: `id/=/${id}`,
  });
  return Boolean(res.status);
}

async function insertCatagory(insertInputs) {
  let res = await insertRecord("tour_tags", {
    title: insertInputs.title,
    ismain: insertInputs.ismain,
  });
  return Boolean(res.status);
}

async function deleteCatagory(id) {
  let res = await deleteRecord("tour_tags", `id/=/${id}`);
  return res.status == 1
}

async function getCatagories() {
  return await findRecord("tour_tags", { fields: "id, title, ismain" });
}

export {
  deleteTour,
  searchTour,
  getTours,
  getFilterMax,
  toggleIsMainCatagory,
  insertCatagory,
  deleteCatagory,
  getCatagories,
};
